import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import CitizenAppeal from './CitizensAppeals';
import AppealSentPage from './AppealSentPage';
import FormEvaluationOfResults from './FormEvaluationOfResults';
import { Loader } from '@smartplatform/ui';

export const CitizensAppeals = () => {
	// Редирект пока не доработан модуль с обращениями
	useEffect(() => {
		location.href = 'https://old.sakha.gov.ru/cabinet/statements/create';
	}, []);

	// Лоадер пока происходит редирект
	return <Loader style={{ display: 'flex', justifyContent: 'center' }} />;

	/*return (
		<Switch>
			<Route path='/citizens-appeals' exact component={CitizenAppeal} />
			<Route path='/citizens-appeals/appeal-sent' component={AppealSentPage} />
			<Route path='/citizens-appeals/form-evaluation-of-results/:id' component={FormEvaluationOfResults} />
		</Switch>
	);*/
};
